import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web--source/slate/Color";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import * as React from "react";
import styled, { css } from "styled-components";
var itemCss = css([
    "height:44px;padding:7px 16px;font-size:16px;cursor:pointer;&:hover,&:focus{background-color:",
    ";}white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;",
    "{font-size:12px;}",
    "{padding:9px 21px 8px 21px;margin-bottom:1px;}"
], Core.surface.subdued + Opacity.O_50, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile);
var ListItem = styled.li.withConfig({
    componentId: "sc-eae39066-0"
})([
    "",
    ""
], itemCss);
export var ResultDropdownItem = function(param) {
    var index = param.index, suggestion = param.suggestion, onHover = param.onHover, onMouseLeave = param.onMouseLeave, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ _jsx(ListItem, {
        onMouseEnter: function() {
            return onHover === null || onHover === void 0 ? void 0 : onHover(index);
        },
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick(suggestion);
        },
        onMouseLeave: onMouseLeave,
        tabIndex: -1,
        children: children
    });
};
